import * as React from 'react'
import { Text } from '@fluentui/react-components'
import { BaseOverviewCount, BaseOverviewHeaderItemProps } from './BaseOverview'
import BaseOverviewCountBadge from './BaseOverviewCountBadge'
import { EntityDto } from '../../config/appConfig'
import { BaseOverviewSortingType } from './BaseSortMenu'
import { BaseOverviewFilterType } from './BaseOverviewFilter'

export default function BaseHeaderItem<
    EntityT extends EntityDto,
    FilterT extends BaseOverviewFilterType,
    SortingT extends BaseOverviewSortingType<any>,
    HeaderT extends BaseOverviewCount = BaseOverviewCount,
>(props: BaseOverviewHeaderItemProps<EntityT, FilterT, SortingT, HeaderT>) {
    return (
        <>
            <BaseOverviewCountBadge {...props} />
            <Text>{(props.fixedColumnFilterValues?.(props.viewType, props.filterValues) || ([{}] as FilterT[]))[props.columnIndex]?.title}</Text>
        </>
    )
}
